export default __webpack_public_path__ + "static/media/keep-tracking-with-an-audit-log.fd119838.jpg";